import { StartType } from '@wix/ambassador-pricing-plans-v3-plan/types';

/**
 * @returns true if the variant allows future start date, false otherwise.
 */

export const allowsFutureStartDate = variant => {
  var _variant$billingTerms;
  return ((_variant$billingTerms = variant.billingTerms) == null ? void 0 : _variant$billingTerms.startType) === StartType.CUSTOM;
};
//# sourceMappingURL=allows-future-start-date.js.map